import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { MedicFavoriteExternalPrescriptionService } from 'src/app/shared/services/API/medic/medic-favorite-external-prescription.service';
import { MedicFavoriteExternalPrescriptionRequest } from 'src/app/shared/services/requests/medic/medic-favorite-external-prescription.request';
import { PrescriptionNonStandard } from '../../services/models/pharmacy/prescription-non-standard.model';

@Component({
  selector: 'app-save-favorite-external-prescription-modal',
  templateUrl: './save-favorite-external-prescription-modal.component.html',
  styleUrls: ['./save-favorite-external-prescription-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SaveFavoriteExternalPrescriptionModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<SaveFavoriteExternalPrescriptionModalComponent>,
    private alertService: AlertService,
    private favoriteExternalPrescriptionService: MedicFavoriteExternalPrescriptionService,
    private formBuilder: FormBuilder
  ) { }

  public model: FormGroup;
  public loading: boolean = false;
  public save: boolean = false;

  ngOnInit(): void {
    if (!this.data.listPrescription || this.data.listPrescription.length === 0) {
      this.clickCancel();
      this.alertService.show('Error', 'Não há prescrições a serem favoritadas', AlertType.error);
    }

    this.model = this.formBuilder.group({
      favoriteName: ['', [Validators.required]]
    });
  }

  clickCancel() {
    this.matDialogRef.close({ save: this.save });
  }

  clickSave() {
    if (this.model.invalid) {
      this.alertService.show('Erro', "O nome do favorito é obrigatório.", AlertType.error);
      return;
    }

    this.loading = true;

    let request = new MedicFavoriteExternalPrescriptionRequest();
    request.favoriteMedicineName = this.model.get('favoriteName')?.value;
    request.shareWithMedicalTeam = false;

    // Concatena todos os textos caso o médico tenha adicionado múltiplos blocos
    let combinedTexts = "";
    if (this.data.listPrescription && this.data.listPrescription.length > 0) {
      combinedTexts = this.data.listPrescription
        .map((p: PrescriptionNonStandard) => p.formattedText)
        .join('<br><br>');
    }
    request.formattedText = combinedTexts;

    this.favoriteExternalPrescriptionService.createMedicFavoriteExternalPrescription(request).subscribe({
      next: (response: any) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.loading = false;
          return;
        }

        this.loading = false;
        this.save = true;
        this.matDialogRef.close({ save: this.save });
      },
      error: (error: string) => {
        this.loading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }
}